/* 縦書きの幅を、実際に並んだ行の数 × 行の高さで決める（2026-10-04）。
   iPhone の Safari（WebKit）は、横書きの箱の中にある縦書き（writing-mode: vertical-rl）の要素について、
   「中身に合わせた幅」を小さく取り違える。そのため、題簽の枠から文字がはみ出したり、縦書きの見出しの列が狭くなって
   ページが横にずれたりする（ユーザーの iPhone で確認：FV・和について・ご褒美・送料・作り方の表紙、TOP 05 など）。
   文字の並び（列）そのものは正しく描かれるので、列の数を数えて、幅をはっきり決める。Chrome では元と同じ幅になる。
   ・対象：縦書きの要素のうち、親が横書きのもの（縦書きの中の縦書きはそのまま）。表示されていないもの・インラインの要素は対象外
   ・画面の幅が変わったとき、文字の読み込みが終わったとき、タブなどで表示が切り替わったときに測り直す */
(() => {
  if (window.kzTateFix) return;
  window.kzTateFix = true;
  const px = (v) => parseFloat(v) || 0;
  const vertical = (cs) => /^vertical/.test(cs.writingMode || cs.webkitWritingMode || '');
  let candidates = [];

  const scan = () => {
    candidates = [];
    document.querySelectorAll('body *').forEach((el) => {
      if (el.closest('svg, script, style, template, noscript')) return;
      const cs = getComputedStyle(el);
      if (vertical(cs) && el.parentElement && !vertical(getComputedStyle(el.parentElement))) candidates.push(el);
    });
  };

  const fix = (el) => {
    const cs = getComputedStyle(el);
    if (!vertical(cs) || cs.display === 'inline' || cs.display === 'none' || cs.display === 'contents') {
      if (el.dataset.kzTate) { el.style.width = ''; delete el.dataset.kzTate; }
      return;
    }
    if (!el.getClientRects().length) return; // 表示されていない（タブの裏など）。表示されたら測り直す
    if (el.dataset.kzTate) el.style.width = '';
    const range = document.createRange();
    range.selectNodeContents(el);
    const lh = px(cs.lineHeight) || px(cs.fontSize) * 1.5;
    const centers = [...range.getClientRects()].filter((r) => r.width > 0.5 && r.height > 0.5).map((r) => r.left + r.width / 2).sort((a, b) => a - b);
    if (!centers.length || !lh) return;
    let lines = 1;
    for (let i = 1; i < centers.length; i++) if (centers[i] - centers[i - 1] > lh * 0.5) lines++;
    let width = lines * lh;
    if (cs.boxSizing === 'border-box') width += px(cs.paddingLeft) + px(cs.paddingRight) + px(cs.borderLeftWidth) + px(cs.borderRightWidth);
    el.style.width = `${Math.ceil(width * 100) / 100}px`;
    el.dataset.kzTate = String(lines);
  };

  let timer = 0;
  const run = (rescan) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (rescan || !candidates.length) scan();
      candidates.forEach(fix);
    }, rescan ? 120 : 60);
  };

  scan();
  candidates.forEach(fix);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => run(false));
  addEventListener('load', () => run(false), { once: true });
  addEventListener('resize', () => run(true), { passive: true });
  addEventListener('orientationchange', () => run(true));
  // タブ・開閉・物語の場面の切り替えなど（表示が変わったら測り直す。style の変化は見ない＝自分の変更で回り続けない）
  new MutationObserver(() => run(false)).observe(document.body, { attributes: true, attributeFilter: ['hidden', 'class', 'open', 'data-current', 'data-product', 'data-fv-phase'], subtree: true, childList: true });
})();
